import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { EnvironmentDetailsRoutingModule } from './environment-details-routing-module';
import { EnvironmentSidebarComponent } from '../environment-sidebar/environment-sidebar.component';
import { EnvironmentDetailsComponent } from './environment-details.component';
import { IconsModule } from 'src/app/icons/icons.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import { EnvironmentHeaderModule } from '../environment-header/environment-header.module';
import { EnvironmentOverviewComponent } from './environment-overview/environment-overview.component';
import { EnvironmentSettingsComponent } from './environment-settings/environment-settings.component';
import { EnvironmentLocalConfigurationComponent } from "./environment-local-configuration/environment-local-configuration.component";
import { EnvironmentEndpointsComponent } from './environment-endpoints/environment-endpoints.component';
import { InstanceSftpComponent } from '../environment-sftp/environment-sftp.component';
import { MatTabsModule } from '@angular/material/tabs';
import {TableModule} from 'src/app/table/table.module';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import {MatMenuModule} from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { InstanceDetailsAddRouteComponent } from 'src/app/components/instance-details/instance-details-add-route/instance-details-add-route.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ErrorModule } from 'src/app/components/error/error.module';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import { GenericErrorModule } from 'src/app/components/generic-error/generic-error.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import { PopupHostDirective } from 'src/app/directives/host.directive';
import { VerifypopupModule } from 'src/app/components/verifypopup/verifypopup.module';
import { SkiptestPopupModule } from 'src/app/components/skiptest-popup/skiptest-popup.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AddSshKeyComponent } from 'src/app/components/instance-details/add-ssh-key/add-ssh-key.component';
import { DatepickerModule } from 'src/app/components/datepicker/datepicker.module';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { monthYearPickerModule } from 'src/app/components/month-year-picker/month-year-picker.module';
import { TimeTakenPieModule } from 'src/app/components/time-taken-info-pie/time-taken-info-pie.module';
import { CommonTableModule } from 'src/app/components/table/table.module';
import { EnvironmentActivityComponent } from './environment-activity/environment-activity.component';
import { EnvironmentCustomPackageComponent } from './environment-custom-package/environment-custom-package.component';
import { MatDivider } from '@angular/material/divider';
import { EnvironmentCompenentUpdateComponent } from './environment-component-update/environment-component-update.component';
import { EnvironmentReleasePackage } from './environment-release-package/environment-release-package';
import { EnvironmentProductRvt } from './environment-product-rvt/environment-product-rvt';
import { EnvironmentInventoryComponent } from './environment-inventory/environment-inventory.component';
import { EnvironmentMetricsComponent } from './environment-metrics/environment-metrics.component';
import { InstanceDetailsModule } from 'src/app/components/instance-details/instance-details.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { EnvironmentDatabaseBackupComponent } from './environment-database-backup-component/environment-database-backup-component';
import { EnvironmentSanitytestComponent } from './environment-sanity-test/environment-sanity-test.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { EnvironmentEFtestComponent } from './environment-ef-test/environment-ef-test.component';
import { EnvironmentCobComponent } from './environment-cob/environment-cob.component';
import { EnvironmentRunbook } from './environment-runbook/environment-runbook';
import { CreateRunbook } from './environment-runbook/create-runbook/create-runbook';
import { DynamicFormModule } from 'src/app/components/dynamic-form/dynamic-form.module';
import { QuestionnaireSummaryModule } from 'src/app/components/questionnaire-summary/questionnaire-summary.module';
import { EnvironmentPaginatorrModule } from "./environment-paginator/environment-paginator.module";
import { EnvironmentTableModule } from './environment-table/environment-table.module';
import { CreateScheduleComponent } from './environment-schedule/create-schedule/create-schedule.component';
import { EnvironmentScheduleComponent } from './environment-schedule/environment-schedule.component';
import { EnvironmentJobs } from './environment-jobs/environment-jobs/environment-jobs';
import { EnvironmentRunbookModule } from './environment-runbook/environment-runbook.module';
import { RunbookPopupModule } from './environment-runbook/runbook-popup/runbook-popup.module';
import { EnvironmentJobDetails } from './environment-jobs/environment-job-details/environment-job-details.component';
import { RedirectionDialogModule } from 'src/app/components/redirection-dialog/redirection-dialog.module';
import { UpdateRunbookVersionModule } from './environment-runbook/update-runbook-version/update-runbook-version.module';
import { EnvironmentSizingDocuments } from './environment-sizing-documents/environment-sizing-documents';
import { EnvironmentSizingDocumentsModule } from './environment-sizing-documents/environment-sizing-documents.module';
import { EnvironmentUpdateManagerComponent } from './environment-update-manager/environment-update-manager.component';
import { SchedulerComponentUpdateModule } from './environment-update-manager/environment-scheduler-component-update/environment-scheduler-component-update.module';
import { EnvironmentApplyLocalConfigComponent } from './environment-apply-local-config/environemnt-apply-local-config.component';
import { EnvironmentDependencyTreeComponent } from './environment-dependency-tree/environment-dependency-tree.component';
import { EnvironmentBaseImageComponent } from './environment-base-image/environment-base-image.component';
import { BaseImageDetailPopupModule } from './environment-base-image/base-image-detail-popup/base-image-detail-popup.module';
import { MatButtonModule } from '@angular/material/button';
import { ThresholdDialogModule } from 'src/app/components/threshold-dialog-component/threshold-dialog-component.module';
import { EnvironmentActivityDetails } from './environment-activity-details/environment-activity-details';
import { MatIconModule } from '@angular/material/icon';
import { EnvironmentActivityPopupComponent } from './environment-activity/environment-activity-popup/environment-activity-popup.component';
import { ActivityLeftPanelComponent } from './environment-activity/environment-activity-popup/activity-left-panel/activity-left-panel.component';
import { ActivityRightPanelComponent } from './environment-activity/environment-activity-popup/activity-right-panel/activity-right-panel.component';

@NgModule({
  declarations: [
    EnvironmentDetailsComponent,
    EnvironmentSidebarComponent,
    EnvironmentOverviewComponent,
    EnvironmentReleasePackage,
    EnvironmentProductRvt,
    EnvironmentSettingsComponent,
    EnvironmentLocalConfigurationComponent,
    EnvironmentEndpointsComponent,
    EnvironmentInventoryComponent,
    EnvironmentMetricsComponent,
    EnvironmentActivityComponent,
    EnvironmentCompenentUpdateComponent,
    EnvironmentCustomPackageComponent,
    EnvironmentMetricsComponent,
    EnvironmentDatabaseBackupComponent,
    EnvironmentSanitytestComponent,
    EnvironmentEFtestComponent,
    EnvironmentCobComponent,
    EnvironmentCustomPackageComponent,
    InstanceSftpComponent,
    EnvironmentRunbook,
    CreateRunbook,
    CreateScheduleComponent,
    EnvironmentScheduleComponent,
    EnvironmentJobs,
    EnvironmentJobDetails,
    EnvironmentSizingDocuments,
    EnvironmentUpdateManagerComponent,
    EnvironmentApplyLocalConfigComponent,
    EnvironmentDependencyTreeComponent,
    EnvironmentBaseImageComponent,
    EnvironmentActivityDetails,
    EnvironmentActivityPopupComponent,
    ActivityLeftPanelComponent,
    ActivityRightPanelComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    EnvironmentDetailsRoutingModule,
    IconsModule,
    PipesModule,
    BreadcrumbModule,
    MatTooltipModule,
    EnvironmentHeaderModule,
    MatDividerModule,
    IconsModule,
    MatTabsModule,
    TableModule,
    SidenavHeaderModule,
    NgxSkeletonLoaderModule,
    InstanceDetailsModule,
    SearchFilterModule,
    MatTabsModule,
    ClipboardModule,
    MatDividerModule,
    MatExpansionModule,
    MatTooltipModule,
    ToolbarModule,
    MatMenuModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    ErrorModule,
    MatSelectModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    PaginatorModule,
    GenericErrorModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDialogModule,
    VerifypopupModule,
    SkiptestPopupModule,
    NgxSkeletonLoaderModule,
    MatSortModule,
    DatepickerModule,
    CommonTableModule,
    BreadcrumbModule,
    NgxEchartsModule.forRoot({
      echarts
    }),
    monthYearPickerModule,
    TimeTakenPieModule,
    CommonTableModule,
    MatProgressSpinnerModule,
    MatDivider,
    CommonTableModule,
    MatTableModule,
    MatSortModule,
    TableModule,
    PaginatorModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    DynamicFormModule,
    QuestionnaireSummaryModule,
    EnvironmentPaginatorrModule,
    EnvironmentTableModule,
    EnvironmentRunbookModule,
    RunbookPopupModule,
    RedirectionDialogModule,
    UpdateRunbookVersionModule,
    EnvironmentSizingDocumentsModule,
    SchedulerComponentUpdateModule,
    MatButtonModule,
    BaseImageDetailPopupModule,
    ThresholdDialogModule,
    MatIconModule
  ],
  providers: [DatePipe]
})
export class EnvironmentDetailsModule { }
